/* eslint-disable @typescript-eslint/no-explicit-any */
export const getDestination = (link: any) => {
  if (!link) return '/';

  const { slug, cta } = link;

  if (slug) {
    return slug === 'homepage' ? '/' : slug?.endsWith('/') ? slug : `${slug}/`;
  }

  return cta?.externalUrl;
};

export const createLink = (href: string, locale: string, dontPrefixLocale = true) => {
  if (dontPrefixLocale) {
    return `/${href}`.replace('//', '/');
  }

  return `/${locale}/${href}`.replace('//', '/');
};
